import { render, staticRenderFns } from "./WhirelabTextArea.vue?vue&type=template&id=38618e16&scoped=true"
import script from "./WhirelabTextArea.vue?vue&type=script&lang=js"
export * from "./WhirelabTextArea.vue?vue&type=script&lang=js"
import style0 from "./WhirelabTextArea.vue?vue&type=style&index=0&id=38618e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38618e16",
  null
  
)

export default component.exports